var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "copy-link" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "复制链接",
            visible: _vm.dialogVisible,
            width: "50%",
            "destory-on-close": "",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.tableData },
            },
            [
              _c("el-table-column", {
                attrs: { label: "分销客户", prop: "customerName" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "链接", prop: "linkUrl" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "copy",
                                rawName: "v-copy",
                                value: scope.row.linkUrl,
                                expression: "scope.row.linkUrl",
                              },
                            ],
                            attrs: { type: "text" },
                          },
                          [_vm._v("复制链接")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "二维码", prop: "qrCode" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          attrs: {
                            "preview-src-list": [scope.row.qrCode],
                            src: scope.row.qrCode,
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [_c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")])],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }